import estilos from './servicios/Pie.module.css';

function Pie() {
    return (
      <footer className={estilos.footer}>
        Desarrollado y Diseñado por Gerardo Emmanuel Guerrero Cerón | gerardoe.com ©2024. Reservados todos los derechos
      </footer>
    );
  };
  
  export default Pie;
  